import { useEffect, useState } from "react";
import api, { fmtUSD } from "@/lib/api";
import { Panel, Metric } from "@/components/terminal";

const TIERS = [
  { label: "Drawdown < 5%", pct: 0, note: "Do not use reserve" },
  { label: "5 – 10%", pct: 5, note: "Permit 5% of opportunity reserve" },
  { label: "10 – 15%", pct: 10, note: "Permit 10%" },
  { label: "15 – 20%", pct: 20, note: "Permit 20%" },
  { label: "20 – 30%", pct: 30, note: "Permit 30%" },
  { label: "30%+", pct: "staged", note: "Staged deployment subject to Risk Governor" },
];

export default function Opportunities() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/opportunities").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-slate-500 font-mono text-sm">Loading…</div>;
  return (
    <div className="space-y-5" data-testid="opportunities-page">
      <h2 className="font-display text-xl font-bold">Opportunity Reserve</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Metric label="Reserve Balance" value={fmtUSD(d.opportunity_reserve)} testId="opp-reserve-balance" />
        <Metric label="Market Drawdown (BTC from 90d high)" value={`${d.market_drawdown_pct}%`} testId="opp-drawdown" />
        <Metric label="Active Tier" value={d.tier.replace(/_/g, " ")} tone="gold" testId="opp-tier" />
        <Metric label="Permitted Deployment" value={fmtUSD(d.permitted_amount)} sub={`${d.permitted_pct_of_reserve}% of reserve`} testId="opp-permitted" />
      </div>
      <Panel title="Deployment Ladder" testId="opp-ladder">
        <div className="space-y-2">
          {TIERS.map((t, i) => {
            const active = (i === 0 && d.tier === "NO_DEPLOYMENT") || d.tier === `TIER_${i}` || (i === 5 && d.tier === "STAGED_MAX");
            return (
              <div key={t.label} className={`flex items-center justify-between px-4 py-2.5 rounded-sm border ${active ? "border-[#D4AF37]/60 bg-[#D4AF37]/5" : "border-[#222630]"}`} data-testid={`ladder-tier-${i}`}>
                <span className={`text-sm font-semibold ${active ? "gold-text" : "text-slate-400"}`}>{t.label}</span>
                <span className="text-xs text-slate-500">{t.note}</span>
                <span className={`font-mono text-sm ${active ? "gold-text" : "text-slate-500"}`}>{t.pct}{typeof t.pct === "number" ? "%" : ""}</span>
              </div>
            );
          })}
        </div>
        <p className="text-[10px] text-slate-600 mt-3">{d.note}</p>
      </Panel>
    </div>
  );
}
